module.exports = __webpack_public_path__ + "resource/img/comments.jpg?69df21c51a2ccf7c8c10329c3dd1deb0";


//////////////////
// WEBPACK FOOTER
// ./src/images/comments.jpg
// module id = 445
// module chunks = 36